// Resolve each category independently for targets and actuals, avoiding parent/child double counting.
export function forecastYearRows(rawMonths, sections) {
  const template=sections.flatMap(s=>s.lines.filter(l=>l.kind!=='computed').map(l=>({...l,section:s.key})));
  return Object.fromEntries(Object.entries(rawMonths).map(([month,rows])=>{
    const byKey=Object.fromEntries(rows.map(r=>[r.line_key,r]));
    return [month,template.map((line,index)=>{
      const value=col=>{
        const childValues=(line.children||[]).map(c=>byKey[c.key]?.[col]).filter(v=>v!=null);
        return childValues.length?childValues.reduce((s,v)=>s+Number(v),0):byKey[line.key]?.[col]??null;
      };
      return {month,line_key:line.key,line_label:line.label,section:line.section,sort_order:index,forecast_amount:value('forecast_amount'),actual_amount:value('actual_amount')};
    })];
  }));
}
